<fui-pill-fascia (clicked$)="click()" [disabled]="disabled" [focussed]="focussed" (focussed$)="focus()"
                 [hovered]="hovered" [ngClass]="'clickable'">
    <fui-fixtures>
        <fui-fixture *ngIf="!disabled">
            <fui-mark-toggle [toggled]="popped">
                <fui-icon [height]="8" [icon]="'chevron-down'" [width]="10"></fui-icon>
            </fui-mark-toggle>
        </fui-fixture>
        <fui-fixture>
            <fui-pill-label [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                            [title]="label"></fui-pill-label>
        </fui-fixture>
        <fui-spanning-fixture *ngIf="showSelections">
            <fui-input-dom *ngIf="!disabled || !selections || !selections.length || !optionOpenable">
                <input (blur)="onBlur($event)" #input (focus)="onFocus($event)" [ngModel]="selected"
                       [placeholder]="placeholder | translate" [readonly]="true" [tabindex]="tabindex" type="text">
            </fui-input-dom>
            <div *ngIf="disabled && selections && selections.length && optionOpenable" class="multiselect-links">
                <span *ngFor="let selection of selections" class="multiselect-links-link">
                    <span class="multiselect-links-link-text"
                          (click)="openOption($event, selection)">{{selection[key]}}</span>
                </span>
            </div>
        </fui-spanning-fixture>
        <fui-fixture *ngIf="removable">
            <fui-mark-button (click)="remove()">
                <fui-icon [height]="6" [icon]="'close'" [width]="6"></fui-icon>
            </fui-mark-button>
        </fui-fixture>
    </fui-fixtures>
</fui-pill-fascia>
<fui-select-pop [popped]="popped" (popped$)="pop($event)">
    <fui-sections>
        <fui-content-section *ngIf="loading">
            <fui-loading>
                <fui-ellipsis-loader></fui-ellipsis-loader>
            </fui-loading>
        </fui-content-section>
        <fui-fab-section *ngIf="searchable()">
            <fui-fragments>
                <fui-fragment>
                    <fui-search-control [(ngModel)]="query"
                                        [label]="'Filter'" [placeholder]="'Filter by name'"></fui-search-control>
                </fui-fragment>
            </fui-fragments>
        </fui-fab-section>

        <fui-list-section *ngIf="filled(selections)">
            <fui-multiselect-options [field]="field" [key]="key" [filteredOptions]="selections" id="selections"
                                     [optionOpenable]="optionOpenable"
                                     (optionOpened$)="optionOpened$.emit($event)"
                                     (changeSelections$)="select($event)">
                <fui-clear-button [title]="'fui.select-control.label.clearSelected'"
                                  (click)="clearSelection($event)"></fui-clear-button>
            </fui-multiselect-options>
        </fui-list-section>

        <fui-content-section *ngIf="empty(filteredOptions) && empty(selections)">
            <fui-empty>
                <fui-icon [height]="32" [icon]="'search-group'" [width]="32"></fui-icon>
            </fui-empty>
        </fui-content-section>
        <fui-section *ngIf="filled(filteredOptions)">
            <fui-multiselect-options [field]="field" [key]="key" [options]="options"
                                     [filteredOptions]="filteredOptions" id="options"
                                     [optionOpenable]="optionOpenable"
                                     (optionOpened$)="optionOpened$.emit($event)"
                                     [allowLabelMarkup]="allowLabelMarkup"
                                     (selections$)="select($event)"></fui-multiselect-options>
        </fui-section>
        <fui-ftb-section *ngIf="ftb()">
            <fui-fragments>
                <fui-fragment *ngIf="addable || (options.length > 0 && extendable) || actions">
                    <fui-buttons>
                        <fui-mark-button (click)="extend()" *ngIf="options.length > 0 && extendable"
                                         [attr.title]="'fui.common.button.search' | translate"
                                         id="extended-search-button">
                            <fui-icon [height]="12" [icon]="'lookup'" [width]="12"></fui-icon>
                        </fui-mark-button>
                        <fui-mark-button (click)="add()" *ngIf="addable"
                                         [attr.title]="'fui.common.button.addNew' | translate"
                                         id="add-new-button">
                            <fui-icon [height]="12" [icon]="'plus'" [width]="12"></fui-icon>
                        </fui-mark-button>
                        <fui-action *ngFor="let a of actions" [disabled]="a.disabled"
                                    [attr.title]="a.title | translate" (click)="actionClicked(a)">
                            <fui-icon [height]="a.iconHeight || 12" [width]="a.iconWidth || 12"
                                      [icon]="a.icon"></fui-icon>
                        </fui-action>
                    </fui-buttons>
                </fui-fragment>
                <fui-fragment *ngIf="limited()">
                    <fui-limit-total [limit]="filteredOptions.length" [total]="total"></fui-limit-total>
                </fui-fragment>
            </fui-fragments>
        </fui-ftb-section>
    </fui-sections>
</fui-select-pop>
